var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWello = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m18.124 3.938-3.395 14.668H9.938l-1.136-6.313-1.458 6.313H2.836L0 8.174l4.661-1.09.914 6.247 1.3-6.764 3.809-.89 1.399 7.753.882-8.285 5.157-1.205zM23.998 6.487l-2.269 8.484h-3.615L19.49 4.17 24 6.487zM21.43 17.962a2.052 2.052 0 1 1-4.105 0 2.052 2.052 0 0 1 4.105 0"
})));
export default SvgWello;